import { render } from "./IpList.vue?vue&type=template&id=ba80c726&ts=true"
import script from "./IpList.vue?vue&type=script&lang=ts"
export * from "./IpList.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__